type DesignIdentity = {
  lite: boolean;
  product: string;
  projectId: string | null;
};

function designIdentity(pathname: string): DesignIdentity | null {
  const parts = pathname.split('/').filter(Boolean);
  if (parts[0] !== 'project') {
    return null;
  }

  if (parts[1] === 'lite' && parts[2] === 'design' && parts[3]) {
    return { lite: true, product: parts[3], projectId: parts[4] || null };
  }

  if (parts[1] === 'design' && parts[2]) {
    return { lite: false, product: parts[2], projectId: parts[3] || null };
  }

  return null;
}

// First autosave and the SM redirect rewrite these slugs onto one design URL.
// SM Ascender Flush becomes solarmount_2. SM Tilt PR Ascender becomes sm_tilt_pr.
const CANONICAL_DESIGN_PRODUCTS: readonly (readonly string[])[] = [
  ['solarmount_2', 'solarmount_lt', 'solarmount_hd', 'solarmount_ascender_flush'],
  ['sm_tilt_pr', 'sm_tilt_pr_lt', 'sm_tilt_pr_ascender_rail'],
];

function sameDesignProduct(previous: string, next: string): boolean {
  if (previous === next) {
    return true;
  }
  return CANONICAL_DESIGN_PRODUCTS.some(
    (group) => group.includes(previous) && group.includes(next),
  );
}

// True when a URL update is still the same design editor. The first autosave
// appends a project id; that must not be treated as leaving the editor.
export function sameDesignSession(previousPath: string, nextPath: string): boolean {
  if (previousPath === nextPath) {
    return true;
  }

  const previous = designIdentity(previousPath);
  const next = designIdentity(nextPath);
  if (!previous || !next) {
    return false;
  }
  if (previous.lite !== next.lite || !sameDesignProduct(previous.product, next.product)) {
    return false;
  }
  if (previous.projectId && next.projectId) {
    return previous.projectId === next.projectId;
  }
  return true;
}
